module.exports = __webpack_public_path__ + "img/Menu-1311.21b6fe3b.png";